// App utils
import { datajsFirst } from '../shared/utils';

(function() {
	const fixedHeader = () => {
		let initialLoad = true;
		let ticking = false;
		let lastScrollTop = 0;
		const delta = 5;
		const headerHeight = datajsFirst('site-header').offsetHeight;

		if (!window.requestAnimationFrame) {
			return;
		}

		const update = () => {
			ticking = false;

			if (initialLoad) {
				initialLoad = false;
				return;
			}

			const st = window.pageYOffset || document.documentElement.scrollTop;

			if (Math.abs(lastScrollTop - st) <= delta) {
				return;
			}

			// If current position > last position AND scrolled past navbar...
			if (st > lastScrollTop && st > headerHeight) {
				// Scroll Down
				document.body.classList.add('is-scrollingDown');
				document.body.classList.remove('is-scrollingUp');
			} else if (st < lastScrollTop && st > headerHeight) {
				// Scroll Up
				document.body.classList.add('is-scrollingUp');
				document.body.classList.remove('is-scrollingDown');
			} else {
				document.body.classList.remove('is-scrollingDown');
				document.body.classList.remove('is-scrollingUp');
			}

			lastScrollTop = st;
		};

		const requestTick = () => {
			if (!ticking) {
				window.requestAnimationFrame(update);
			}
			ticking = true;
		};

		window.addEventListener('scroll', requestTick, false);
	};

	document.addEventListener('DOMContentLoaded', fixedHeader);
})();
